import { DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransmissionStatusQuickInfo extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelBatch: Label;
    labelBatchText: Label;
    linkToClassic: Image;
    panel1: Panel;
    panelTransmission: Panel;
    sourceEdiLog: DataSource;
    textboxFilename: Textbox;
    textboxStatus: Textbox;
    textboxSuccessful: Textbox;
    textboxTransLogDate: Textbox;
    textboxTransactionType: Textbox;
}
